export default __webpack_public_path__ + "static/media/horizontal_belonging.89bf93a0.jpg";